<template>
  <div>
    <ParseForm :formParams='formParams' :emit='emit' formId='dataBusiness' :opCode='opCode' :funcClick='bindClickInterface' ref='bus'></ParseForm>
    <CustomDialog ref='userTableLayerDialog' :element='dialog.element.eleUserTable' :styles='dialog.styles' :messages='dialog.messages'>
      <template v-slot:dialog-content>
        <UserTableLayer ref="userTableLayer"></UserTableLayer>
      </template>
    </CustomDialog>
    <CustomDialog ref='groupTableLayerDialog' :element='dialog.element.eleGroupTable' :styles='dialog.styles' :messages='dialog.messages'>
      <template v-slot:dialog-content>
        <GroupTableLayer ref="groupTableLayer"></GroupTableLayer>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';
import CustomDialog from '../../../common/CustomDialog';
import UserTableLayer from './dialog/userTableLayer';
import GroupTableLayer from './dialog/groupTableLayer';
import bus from './bus';

export default {
  name: 'U_DataBusiness',
  props: [
    'formParams',
    'reMountPage',
    'clickFunc',
    'info',
    'gmsInfo',
    'opCode'
  ],
  components: {
    ParseForm,
    CustomDialog,
    UserTableLayer,
    GroupTableLayer
  },
  data() {
    return {
      dialog: {
        element: {
          eleUserTable: {
            target: this.$refs.userTableLayer,
            refName: 'eleUserTable',
            buttonGroup: [
              { click: this.closeTablePage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveData, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.addUser'),
            isClose: true
          },
          eleGroupTable: {
            target: this.$refs.groupTableLayer,
            refName: 'eleGroupTable',
            buttonGroup: [
              { click: this.closeGroupTablePage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveGroupData, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.userInfo'),
            isClose: true
          },        },
        styles: {
          width: '700px',
          height: '500px',
          visible: false,
          model: true,
          zIndex: 1001
        },
        messages: this.$t("MCS.userInfo")
      },
      dialogParamName: '',
      funcMap: ''
    };
  },
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    emit(attr) {
      bus.$emit('eventBus', attr);
    },
    reMount() {
      this.$refs.bus.reMount();
      this.bindClickInterface();
    },
    saveData() {
      this.$refs.bus.setData(this.dialogParamName, this.$refs.userTableLayer.getClickData() === undefined ? '' : this.$refs.userTableLayer.getClickData().userNum);
      this.closeTablePage();
    },
    closeTablePage() {
      this.$refs.userTableLayerDialog.clear();
      this.$refs.userTableLayerDialog.close();
    },
    saveGroupData() {
      this.$refs.bus.setData(this.dialogParamName, this.$refs.groupTableLayer.getClickData() === undefined ? '' : parseInt((this.$refs.groupTableLayer.getClickData().groupid).substr(4)));
      this.closeGroupTablePage();
    },
    closeGroupTablePage() {
      this.$refs.groupTableLayerDialog.clear();
      this.$refs.groupTableLayerDialog.close();
    },
    $bindEmergentNum(key) {
      this.funcMap.set(key, () => {
        this.$refs.userTableLayer.getGridData(this.info);
        this.$refs.userTableLayerDialog.show();
        this.dialogParamName = key;
      });
    },
    $bindEmergentGroupNum(key) {
      this.funcMap.set(key, () => {
        this.$refs.groupTableLayer.getGridData(this.gmsInfo);
        this.$refs.groupTableLayerDialog.show();
        this.dialogParamName = key;
      });
    },
    $bindSwitchFunc(key) {
      const _resMap = new Map();
      switch (key) {
        case 'mcdataClass': {
          _resMap.set(1, this.$checkBoxBitFunc('mcdata_oneToOneEmergencyAlert', 'mcdata_groupEmergencyAlert'));
          break;
        }
        default:
      };
      this.funcMap.set(key, _resMap);
    },
    $checkBoxBitFunc(...paramName) {
      const _resArr = [];
      const $this = this;
      if (paramName.length === 0) return;
      _resArr[0] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', true);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      _resArr[1] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', false);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      return _resArr;
    }

  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.$bindEmergentNum('mcdata_oneToOneEmergencyAlert');
      this.$bindEmergentGroupNum('mcdata_groupEmergencyAlert');
      this.$bindSwitchFunc('mcdataClass');
      return this.funcMap;
    },
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      if (this.$refs.bus === undefined || this.$refs.bus.templetCover === undefined) return;
      this.$refs.bus.templetCover(attr);
    });
  }
};
</script>

<style scoped>

</style>
